import { SELECT_MENU_ITEM, TOGGLE_MENU } from '../actions'

const defaultState = {
  currentItem: 0,
  scroll: false,
  isOpen: false
}
export default function(state = defaultState, action) {
  switch (action.type) {
    case SELECT_MENU_ITEM:
      return { ...state, ...action.payload }
    case TOGGLE_MENU:
      return { ...state, ...{ isOpen: !state.isOpen} }
    default:
      return state
  }
}


// WEBPACK FOOTER //
// ./src/reducers/reducer_menu.js